import ProfileView from './ProfileView';
import './ProfileView.scss';

export default ProfileView;
